import React, { useState } from "react";
import { useLanguage, useModal } from "context";
import { useTranslation } from "react-i18next";
import { passwordIcon, passwordConfirmIcon } from "assets/icons";
import { useParams, useNavigate } from "react-router-dom";
import { validateField } from "helpers/validation";
import { FormButton, InputWithIcon, CloseButton } from "reusableComponents";

import styles from "./styles.module.scss";
import { baseUrl} from "constants/url.constants";

const ResetPasswordModal = ({ email, token }) => {
  //   const { email, token } = useParams();
  const navigate = useNavigate();
  const { closeModal } = useModal();
  const { t } = useTranslation("global");
  const [credentials, setCredentials] = useState({
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const handleClose = () => {
    setCredentials({});
    setErrors([]);
    closeModal();
    navigate("/");
  };

  const realTimeValidation = (e) => {
    const { name, value } = e.target;
    const errorMessage = validateField(name, value, t, credentials);

    setErrors((prevErrors) => {
      const updatedErrors = prevErrors.map((error) => ({ ...error }));
      const errorIndex = updatedErrors.findIndex((err) => err.code === name);

      if (errorMessage) {
        if (errorIndex > -1) {
          updatedErrors[errorIndex] = { code: name, message: errorMessage };
        } else {
          updatedErrors.push({ code: name, message: errorMessage });
        }
      } else if (errorIndex > -1) {
        updatedErrors.splice(errorIndex, 1);
      }

      return updatedErrors;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
    realTimeValidation(e);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
  };

  const handlePasswordReset = async () => {
    const passwordError = validateField(
      "password",
      credentials.password,
      t,
      credentials
    );
    const confirmPasswordError = validateField(
      "password_confirmation",
      credentials.password_confirmation,
      t,
      credentials
    );

    if (passwordError || confirmPasswordError) {
      return;
    }

    try {
      const response = await fetch(
        `${baseUrl}users/resetpwd`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            token,
            password: credentials.password,
            password_confirmation: credentials.password_confirmation,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(data.message);
        setTimeout(() => {
          handleClose();
        }, 2000);
      } else {
        setErrors(data.errors);
      }
    } catch (err) {
      setErrors(err?.errors);
    }
  };

  return (
    <div className={styles.resetPasswordModal}>
      <div className={styles.modalHeader}>
        <p className={styles.modalTitle}>{t("modal.resetpwd.title")}</p>
        <CloseButton closeCallback={handleClose} />
      </div>

      <InputWithIcon
        error={
          Array.isArray(errors)
            ? errors.find((error) => error.code === "password")?.message
            : null
        }
        icon={passwordIcon}
        type="password"
        name="password"
        autoComplete="off"
        onBlur={handleBlur}
        handleChange={handleChange}
        value={credentials.password}
        placeholder={t("modal.login.password")}
      />

      <InputWithIcon
        error={
          Array.isArray(errors)
            ? errors.find((error) => error.code === "password_confirmation")
                ?.message
            : null
        }
        icon={passwordConfirmIcon}
        type="password"
        autoComplete="off"
        onBlur={handleBlur}
        handleChange={handleChange}
        name="password_confirmation"
        value={credentials.password_confirmation}
        placeholder={t("modal.register.passwordConfirmation")}
      />

      {errors &&
        errors
          .filter(
            (error) =>
              error.code !== "password" &&
              error.code !== "password_confirmation"
          )
          .map((error) => (
            <p key={error.code} className={styles.errorMessage}>
              {error.message}
            </p>
          ))}
      {successMessage && (
        <p className={styles.successMessage}>{successMessage}</p>
      )}

      <FormButton
        label={t("buttons.confirm")}
        onClick={handlePasswordReset}
        disabled={
          !credentials.password ||
          !credentials.password_confirmation ||
          errors.length > 0
        }
      />
    </div>
  );
};

export default ResetPasswordModal;
